import { useMemo } from "react";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setLoginModalState } from "./authSlice";

export function useAuthPrompt() {
  const dispatch = useDispatch();

  const promptSignin = useCallback(
    () =>
      dispatch(
        setLoginModalState({
          loginModalShowing: true,
          activeAuthForm: "signIn"
        })
      ),
    [dispatch]
  );

  const promptSignup = useCallback(
    () =>
      dispatch(
        setLoginModalState({
          loginModalShowing: true,
          activeAuthForm: "signUp"
        })
      ),
    [dispatch]
  );

  const promptSigninWithRedirect = useMemo(
    () =>
      (redirectOnCloseTo = null) =>
        dispatch(
          setLoginModalState({
            loginModalShowing: true,
            activeAuthForm: "signIn",
            redirectOnCloseTo
          })
        ),
    [dispatch]
  );

  const dismissAuthPrompt = useCallback(
    () =>
      dispatch(
        setLoginModalState({
          loginModalShowing: false,
          error: null
        })
      ),
    [dispatch]
  );

  return {
    promptSignin,
    promptSignup,
    promptSigninWithRedirect,
    dismissAuthPrompt
  };
}
